import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';
import { invert, upperFirst } from 'lodash-es';

import type { CanceledReasonEnum } from 'src/common/external/bambi-api/bambiApi';
import { OTHER_REASON_PREFIX } from 'src/features/trip/constants';

export const CANCEL_REASONS: CanceledReasonEnum[] = [
  'no show',
  'passenger not ready',
  'passenger refused',
  'passenger unable',
  'scheduling conflict',
  'appointment canceled',
  'user requested',
  'other',
];

export const CANCEL_REASON: { [key: string]: CanceledReasonEnum } = {
  NO_SHOW: 'no show',
  PASSENGER_NOT_READY: 'passenger not ready',
  PASSENGER_REFUSED: 'passenger refused',
  PASSENGER_UNABLE: 'passenger unable',
  SCHEDULING_CONFLICT: 'scheduling conflict',
  APPOINTMENT_CANCELED: 'appointment canceled',
  USER_REQUESTED: 'user requested',
  OTHER: 'other',
};

export const CANCEL_REASONS_DISPLAY: { [key: string]: string } = {
  NO_SHOW: 'No show',
  PASSENGER_NOT_READY: 'Passenger not ready for discharge',
  PASSENGER_REFUSED: 'Passenger refused service',
  PASSENGER_UNABLE: 'Passenger unable to be transported',
  SCHEDULING_CONFLICT: 'Scheduling conflict',
  APPOINTMENT_CANCELED: 'Appointment canceled',
  USER_REQUESTED: 'User requested cancellation',
  OTHER: 'Other',
};

export const getCancelReasonDisplay = (reason: string) => {
  if (!reason) return '';
  const invertedCancelReasons = invert(CANCEL_REASON);
  const cancelReason = invertedCancelReasons[reason];

  if (reason.startsWith(OTHER_REASON_PREFIX)) {
    return reason.replace(OTHER_REASON_PREFIX, 'Other: ');
  }
  return CANCEL_REASONS_DISPLAY[cancelReason] || upperFirst(reason);
};

export const CANCEL_REASONS_OPTIONS: SelectOption<CanceledReasonEnum>[] =
  CANCEL_REASONS.map((reason) => ({
    value: reason,
    label: getCancelReasonDisplay(reason),
  }));
